var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyclesmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.06A6.92 6.92 0 0 0 2.06 9 .56.56 0 0 1 .94 9 8.05 8.05 0 0 1 9 .94a9.24 9.24 0 0 1 5.99 2.21c.36.31.68.62.95.9V1.92a.56.56 0 1 1 1.12 0v3.75c0 .31-.25.56-.56.56h-3.33a.56.56 0 1 1 0-1.12h2.2c-.28-.33-.65-.71-1.1-1.1A8.12 8.12 0 0 0 9 2.07Zm7.5 6.38c.31 0 .56.25.56.56A8.07 8.07 0 0 1 9 17.06a7.9 7.9 0 0 1-5.26-2.23c-.32-.29-.6-.58-.85-.85v2.1a.56.56 0 1 1-1.12 0v-3.75c0-.31.25-.56.56-.56h3.4a.56.56 0 1 1 0 1.12H3.43c.27.33.62.72 1.05 1.1 1.1 1 2.64 1.95 4.51 1.95 3.83 0 6.94-3.11 6.94-6.94 0-.31.25-.56.56-.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclesmedium);
export default __webpack_public_path__ + "static/media/cycles.medium.43dde55709f83de62270409c91e9c416.svg";
export { ForwardRef as ReactComponent };